/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Min_Commitment_HintInputs */

const en_admin_resources_min_commitment_hint = /** @type {(inputs: Admin_Resources_Min_Commitment_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum commitment period (e.g. months)`)
};

const de_admin_resources_min_commitment_hint = /** @type {(inputs: Admin_Resources_Min_Commitment_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestlaufzeit (in Monaten)`)
};

const es_admin_resources_min_commitment_hint = /** @type {(inputs: Admin_Resources_Min_Commitment_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compromiso mínimo (en meses)`)
};

const fr_admin_resources_min_commitment_hint = /** @type {(inputs: Admin_Resources_Min_Commitment_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée d'engagement minimum (ex. : en mois)`)
};

const nl_admin_resources_min_commitment_hint = /** @type {(inputs: Admin_Resources_Min_Commitment_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimale verbintenisperiode (bijv. maanden)`)
};

/** @type {(inputs: Admin_Resources_Min_Commitment_HintInputs) => LocalizedString} */
const it_admin_resources_min_commitment_hint = en_admin_resources_min_commitment_hint;

/** @type {(inputs: Admin_Resources_Min_Commitment_HintInputs) => LocalizedString} */
const pt_br2_admin_resources_min_commitment_hint = en_admin_resources_min_commitment_hint;

/** @type {(inputs: Admin_Resources_Min_Commitment_HintInputs) => LocalizedString} */
const pl_admin_resources_min_commitment_hint = en_admin_resources_min_commitment_hint;

/** @type {(inputs: Admin_Resources_Min_Commitment_HintInputs) => LocalizedString} */
const hu_admin_resources_min_commitment_hint = en_admin_resources_min_commitment_hint;

/** @type {(inputs: Admin_Resources_Min_Commitment_HintInputs) => LocalizedString} */
const ro_admin_resources_min_commitment_hint = en_admin_resources_min_commitment_hint;

/**
* | output |
* | --- |
* | "Minimum commitment period (e.g. months)" |
*
* @param {Admin_Resources_Min_Commitment_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_min_commitment_hint = /** @type {((inputs?: Admin_Resources_Min_Commitment_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Min_Commitment_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_min_commitment_hint(inputs)
	if (locale === "de") return de_admin_resources_min_commitment_hint(inputs)
	if (locale === "es") return es_admin_resources_min_commitment_hint(inputs)
	if (locale === "fr") return fr_admin_resources_min_commitment_hint(inputs)
	if (locale === "nl") return nl_admin_resources_min_commitment_hint(inputs)
	if (locale === "it") return it_admin_resources_min_commitment_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_min_commitment_hint(inputs)
	if (locale === "pl") return pl_admin_resources_min_commitment_hint(inputs)
	if (locale === "hu") return hu_admin_resources_min_commitment_hint(inputs)
	return ro_admin_resources_min_commitment_hint(inputs)
});
export { admin_resources_min_commitment_hint as "admin.resources.min_commitment_hint" }